import { render, staticRenderFns } from "./FamousEditList.vue?vue&type=template&id=6e24d611&"
import script from "./FamousEditList.vue?vue&type=script&lang=js&"
export * from "./FamousEditList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports